import '../api/DistanceAPI.js';
import '../aspects/BundeslandAspect.js';
import '../aspects/ZipCityAspect.js';
import './api/ButYearMigration.js';
import './api/EmployeeAPI.js';
import './api/ExportAPI.js';
import './api/RegisterAPI.js';
import './api/StudentAPI.js';
import './api/UserAPI.js';
import './entities/CRVertrag.js';
import './entities/ChancenwerkUser.js';
import './entities/ExternalContactPerson.js';
import './entities/ExternerMitarbeiter.js';
import './entities/HefteTeacher.js';
import './entities/Mitarbeiter.js';
import './entities/Student.js';
import './entities/TemporaryUser.js';
import './entities/VerwaltungsMitarbeiter.js';
import './entities/aspects/ChancenwerkUserAspect.js';
import './entities/aspects/GraduationSubjectAspect.js';
import './entities/aspects/PreferredSubjectAspect.js';
import './entities/aspects/StudentTypeAspect.js';
import './entities/aspects/UserTagAspect.js';
